export default {"src":"/_next/static/media/lovemessage.4055490c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};